export default {
  value: {
    type: Array,
    required: false
  },
  rows: {
    type: Array,
    required: false
  },
  rowsHeader: {
    type: Array,
    required: false
  },
  texto: {
    type: String,
    required: false,
    default: ''
  },
  custom: {
    type: Boolean,
    required: false,
    default: false
  },
  elementsPerPageProp: {
    type: [String, Number],
    required: false,
    default: '05'
  },
  pagina: {
    type: Number,
    required: false,
    default: 0
  },
  qtPaginas: {
    type: Number,
    required: false,
    default: 0
  },
  qtResultados: {
    type: Number,
    required: false,
    default: 0
  },
  items: {
    type: Array,
    required: false
  },
  editar: {
    type: Boolean,
    required: false,
    default: true
  },
  disabledCheckAll: {
    type: Boolean,
    note: 'Desativa botão de selecionar todos os checks'
  },
  nameTab: {
    type: String,
    required: true,
    note: 'Prop para indicar ao componente em qual tab está localizada, ex: perfil, areaAcao, ans, certificacoes, etc'
  },
  disabledAllButtons: {
    type: Boolean,
    required: false,
    default: false
  },
  disabledButtons: {
    type: Array,
    required: false,
    default: () => {
      return [true, true, true, false, false, false]
    },
    note: '0 => view, 1 => edit, 2 => delete, 3 => recibo, 4 => anexo, 5 => refresh, 6 => block'
  },
  showSelect: {
    type: Boolean,
    required: false,
    default: true,
    note: 'Mostrar o Select com as opções'
  },
  showFiltro: {
    type: Boolean,
    required: false,
    default: true,
    note: 'Mostrar o filtro'
  },
  showCheck: {
    type: Boolean,
    required: false,
    default: true,
    note: 'Mostrar os checks na tabela'
  },
  showSelectItens: {
    type: Boolean,
    required: false,
    default: true,
    note: 'Mostrar a seleção de itens por página'
  },
  selectCheckIndex: {
    type: Boolean,
    required: false,
    default: false,
    note: 'Caso queira pegar somente index do check inves do id'
  },
  loading: {
    type: Boolean,
    required: false,
    default: false
  },
  ordemProp: {
    type: String,
    required: false,
    default: 'asc'
  },
  role: {
    type: String,
    required: false
  },
  showAnexo: {
    type: Boolean,
    required: false,
    default: false
  },
  showDownload: {
    type: Boolean,
    required: false,
    default: false
  },
  isConsultarUnimed: {
    type: Boolean,
    required: false,
    default: false
  },
  arrName: {
    type: Array,
    required: false,
    default: () => {
      return ['0', '1', '2', '3', '4', '5', '6']
    }
  },
  botaoSelecionarLixeira: {
    type: Boolean,
    required: false,
    default: true
  },
  botaoBaixarTodos: {
    type: Boolean,
    required: false,
    default: false
  },
  semRegistro: {
    type: String,
    required: false,
    default: 'Nenhum registro encontrado'
  },
  limiteChecks: {
    type: Number,
    required: false
  },
  larguraUltimoHeader: {
    type: [Number, String],
    required: false
  }
}
